import React from "react";
import {
  Box,
  Grid,
  Typography,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import {
  RESIDENCE_CONTENT_LIST,
  PRE_DEPARTURE_CHECK,
  PRE_DEPARTURE_CHECK_SECOND,
} from "./jobprint_constant";
import logoIcon from "../../../assets/images/trunk_1.png";

const ResidenceContetSheet = () => {
  const { leadDetails } = useSelector((state: any) => state.lead);
  const { surveyedSummary } = useSelector((state: any) => state.leadSurvey);

  return (
    <Box
      sx={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "20px",
        fontFamily: "Times New Roman",
        fontSize: "13px",
      }}
    >
      {/* HEADER */}
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <img
            src={leadDetails?.company?.logo ?? logoIcon}
            alt="Trunk Logo"
            style={{ height: "50px" }}
          />
        </Grid>

        <Grid item xs={4} textAlign="center">
          <Typography fontWeight={600}>Customer:</Typography>
          {leadDetails?.lead?.customer_name}
        </Grid>

        <Grid item xs={4} textAlign="right">
          <Typography fontWeight={600}>Date:</Typography>
          {surveyedSummary?.lead?.movingOnDate
            ? dayjs(surveyedSummary?.lead?.movingOnDate)?.format("DD/MM/YYYY")
            : leadDetails?.lead?.moving_on_date
            ? dayjs(leadDetails?.lead?.moving_on_date)?.format("DD/MM/YYYY")
            : "N/A"}
        </Grid>
      </Grid>

      <Box mt={3}>
        <Typography fontWeight="bold" align="center" style={{textDecoration:'underline'}}>
          LOADING ADDRESS – PRE-EXISTING DAMAGE
        </Typography>

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
        >
          <Typography sx={{ fontWeight: 600 }}>
            Removal team contacted me with an estimated time of arrival
          </Typography>
          <Box display="flex" gap={3}>
            <FormControlLabel
              control={<Checkbox size="small" />}
              label="Yes"
              labelPlacement="start"
            />

            <FormControlLabel
              control={<Checkbox size="small" />}
              label="No"
              labelPlacement="start"
            />
          </Box>
        </Box>

        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1} sx={{ fontStyle: "italic" }}>
            Your residence must be inspected for damage on the crew’s arrival
            and upon their departure. We prefer that you walk through the
            residence with the crew leader during inspection and sign in the
            areas below.
          </Typography>
        </Box>
        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1} sx={{lineHeight: 1}}>
            <Checkbox /> <b> RELEASE:</b> I have chosen not to inspect my
            residence with the crew leader and understand this will be performed
            by the crew leader on my behalf. I release <b>Trunk Logistics</b> from all
            liability.
          </Typography>
        </Box>
        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1}>
            <b>UPON ARRIVAL:</b> Note pre-existing damage. Please check YES to
            note an item is damaged or NO if it is not damaged.
          </Typography>
        </Box>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {RESIDENCE_CONTENT_LIST.map((item, index) => (
            <React.Fragment key={index}>
              <Grid item xs={2} style={{ paddingTop: '0px',paddingLeft: '0px' }}>
                <Typography fontWeight="bold">{item.label}</Typography>
              </Grid>

              <Grid item xs={4} textAlign="center" style={{ paddingTop: '0px', paddingLeft: '0px' }}>
                <Box display="flex" gap={3}>
                  <FormControlLabel
                    control={<Checkbox size="small" />}
                    label="Yes"
                    labelPlacement="start"
                  />

                  <FormControlLabel
                    control={<Checkbox size="small" />}
                    label="No"
                    labelPlacement="start"
                  />
                </Box>
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1}>
            If YES to anything above, please describe the damage and take
            photo(s):
          </Typography>
        </Box>

        <hr style={{ margin: "8px 0px" }} />

        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1} style={{textDecoration:'underline'}}>
            <b>PRE-DEPARTURE CHECK:</b>
          </Typography>
        </Box>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {PRE_DEPARTURE_CHECK.map((item, index) => (
            <React.Fragment key={index}>
              <Grid item xs={7} style={{ paddingTop: 0 }}>
                <Typography fontWeight={600}>{item.label}</Typography>
              </Grid>

              <Grid item xs={5} textAlign="center" style={{ paddingTop: 0 }}>
                <Box display="flex" gap={3}>
                  <FormControlLabel
                    control={<Checkbox size="small" />}
                    label="Yes"
                    labelPlacement="start"
                  />

                  <FormControlLabel
                    control={<Checkbox size="small" />}
                    label="No"
                    labelPlacement="start"
                  />
                </Box>
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1}>
            If YES to new damages, please describe the damage and take
            photos(s):
          </Typography>
        </Box>
        <hr style={{ margin: "8px 0px 16px" }} />
        <hr style={{ margin: "8px 0px" }} />

        <Box mt={1} display="flex" alignItems="center" justifyContent="center">
          <Typography mr={1} sx={{ fontWeight: 600, textAlign: "center" }} style={{textDecoration:'underline'}}>
            PAYMENT
          </Typography>
        </Box>
        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1}>Full name of paying customer:</Typography>
          <Box
            sx={{
              flex: 1,
              borderBottom: "1px solid black",
              marginTop: "auto",
            }}
          />
        </Box>
        <Box mt={1} display="flex" alignItems="center">
          <>
            <Typography mr={1}>Full amount paid:</Typography>
            <Box
              sx={{
                flex: 1,
                borderBottom: "1px solid black",
                marginTop: "auto",
                marginRight: "16px",
              }}
            />
          </>
          <>
            <Typography mr={1}>Method:</Typography>
            <Box
              sx={{
                flex: 1,
                borderBottom: "1px solid black",
                marginTop: "auto",
                marginRight: "16px",
              }}
            />
          </>
          <>
            <Typography mr={1}>Paid to:</Typography>
            <Box
              sx={{
                flex: 1,
                borderBottom: "1px solid black",
                marginTop: "auto",
              }}
            />
          </>
        </Box>
        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1}>Customer Signature:</Typography>
          <Box
            sx={{ flex: 1, borderBottom: "1px solid black", marginTop: "auto" }}
          />
        </Box>
        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1}>Crew leader signature:</Typography>
          <Box
            sx={{ flex: 1, borderBottom: "1px solid black", marginTop: "auto" }}
          />
        </Box>
      </Box>
      {/*  */}
      <Box mt={3}>
        <Typography fontWeight="bold" align="center" style={{textDecoration:'underline'}}>
          DELIVERY ADDRESS – PRE-EXISTING DAMAGE
        </Typography>

        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1}>
            Your residence must be inspected for damage on the crew’s arrival
            and upon their departure. We prefer that you walk through the
            residence with the crew leader during inspection and sign in the
            areas below.
          </Typography>
        </Box>
        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1}>
            <Checkbox />
            <b>RELEASE:</b> I have chosen not to inspect my residence with the
            crew leader and understand this will be performed by the crew leader
            on my behalf. I release Trunk Logistics from all liability.
          </Typography>
        </Box>
        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1}>
            <b>UPON ARRIVAL:</b> Note pre-existing damage. Please check YES to
            note an item is damaged or NO if it is not damaged.
          </Typography>
        </Box>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {RESIDENCE_CONTENT_LIST.map((item, index) => (
            <React.Fragment key={index}>
              <Grid item xs={2} style={{ paddingTop: 0 }}>
                <Typography fontWeight={600}>{item.label}</Typography>
              </Grid>

              <Grid item xs={4} textAlign="center" style={{ paddingTop: 0 }}>
                <Box display="flex" gap={3}>
                  <FormControlLabel
                    control={<Checkbox size="small" />}
                    label="Yes"
                    labelPlacement="start"
                  />

                  <FormControlLabel
                    control={<Checkbox size="small" />}
                    label="No"
                    labelPlacement="start"
                  />
                </Box>
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1}>
            If YES to anything above, please describe the damage and take
            photo(s):
          </Typography>
        </Box>

        <hr style={{ margin: "8px 0px" }} />

        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1} style={{textDecoration:'underline'}}>
            <b>PRE-DEPARTURE CHECK:</b>
          </Typography>
        </Box>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {PRE_DEPARTURE_CHECK_SECOND.map((item, index) => (
            <React.Fragment key={index}>
              <Grid item xs={7} style={{ paddingTop: 0 }}>
                <Typography fontWeight={600}>{item.label}</Typography>
              </Grid>

              <Grid item xs={5} textAlign="center" style={{ paddingTop: 0 }}>
                <Box display="flex" gap={3}>
                  <FormControlLabel
                    control={<Checkbox size="small" />}
                    label="Yes"
                    labelPlacement="start"
                  />

                  <FormControlLabel
                    control={<Checkbox size="small" />}
                    label="No"
                    labelPlacement="start"
                  />
                </Box>
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
        <Box mt={1} display="flex" alignItems="center" justifyContent="center">
          <Typography fontWeight="bold" style={{textDecoration:'underline', textAlign:'center'}}>
            DISCLAIMER
          </Typography>
        </Box>
        <Box mt={1} alignItems="center">
          <Typography mr={1}>
            I, the customer, confirm that I give permission for the crew to
            carry out the actions described below and take full responsibility
            for any damages incurred as a result.
          </Typography>
          <Box display="flex" gap={3}>
            <FormControlLabel
              control={<Checkbox size="small" />}
              label="Yes"
              labelPlacement="start"
            />

            <FormControlLabel
              control={<Checkbox size="small" />}
              label="No"
              labelPlacement="start"
            />
          </Box>
        </Box>
        <hr style={{ margin: "8px 0px 16px" }} />
        <hr style={{ margin: "8px 0px" }} />

        <Box mt={1} display="flex" alignItems="center" justifyContent="center">
          <Typography mr={1} sx={{ fontWeight: 600, textAlign: "center" }} style={{textDecoration:'underline'}}>
            CONFIRMATION
          </Typography>
        </Box>
        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1}>
            Please sign and date after all relevant sections of this form have
            been completed:
          </Typography>
        </Box>

        <Box mt={1} display="flex" alignItems="center">
          <>
            <Typography mr={1}>Customer:</Typography>
            <Box
              sx={{
                flex: 1,
                borderBottom: "1px solid black",
                marginTop: "auto",
                marginRight: "16px",
              }}
            />
          </>
          <>
            <Typography mr={1}>Date:</Typography>
            <Box
              sx={{
                flex: 1,
                borderBottom: "1px solid black",
                marginTop: "auto",
                marginRight: "16px",
              }}
            />
          </>
          <>
            <Typography mr={1}>Time:</Typography>
            <Box
              sx={{
                flex: 1,
                borderBottom: "1px solid black",
                marginTop: "auto",
              }}
            />
          </>
        </Box>
        <Box mt={1} display="flex" alignItems="center">
          <>
            <Typography mr={1}>Crew leader:</Typography>
            <Box
              sx={{
                flex: 1,
                borderBottom: "1px solid black",
                marginTop: "auto",
                marginRight: "16px",
              }}
            />
          </>
          <>
            <Typography mr={1}>Date:</Typography>
            <Box
              sx={{
                flex: 1,
                borderBottom: "1px solid black",
                marginTop: "auto",
                marginRight: "16px",
              }}
            />
          </>
          <>
            <Typography mr={1}>Time:</Typography>
            <Box
              sx={{
                flex: 1,
                borderBottom: "1px solid black",
                marginTop: "auto",
              }}
            />
          </>
        </Box>
      </Box>
    </Box>
  );
};

export default ResidenceContetSheet;

